import {Component, input, output} from '@angular/core';
import {NgClass, NgOptimizedImage} from "@angular/common";

@Component({
    selector: 'menu-button',
    standalone: true,
    host: {
        '[class.selected]': 'isSelected()',
        '[class.border-company-color]': 'isSelected()',
    },
    imports: [
        NgOptimizedImage,
        NgClass
    ],
    templateUrl: './menu-button.component.html',
    styleUrl: './menu-button.component.scss'
})
export class MenuButtonComponent {
    subtitle = input.required<string>();
    isOpen = input<boolean | undefined>(undefined);
    isModule = input(false);
    isOption = input(false);
    isActive = input(false);
    isSelected = input(false);
    buttonClick = output<void>();
}
